import React, { useEffect, useState } from 'react'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import {
  Tabs,
  Tab, Backdrop, CircularProgress
} from '@mui/material'
import PropTypes from 'prop-types'
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

import './flights.css'
import SpecialFare from './SpecialFare'
import Banner from './Banner'
import Topdeals from '../../top-deals/Topdeals'
import HotelTopdeals from '../../top-deals-hotel/HotelTopdeals'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Spinner from '../../Spinner'
import SpecialOffer from '../../special-offer/SpecialOffer'
import { getAuth } from '../../../utility/apiConfig'
import { API_BASE_URL } from '../../../utility/apiConstants'
import GroupfaresLink from '../../groupefare-link/GroupfaresLink'
import MobileAppBanner from '../../mobile-app-banner/MobileAppBanner'

const FlightSpecialFare = () => {
    const history = useHistory()
    const reduxData = useSelector(state=>state.user)
    const [waitForRedux, setWaitForRedux] = useState(true)
    const [initialLoad, setInitialLoad] = useState(false);
    const [airportList, setAirportList] = useState([])
    useEffect(() => {
        if(reduxData.userDetails && !reduxData.userDetails.special_fare)
        {
            setWaitForRedux(false)
            history.push('/flight')
        }else{
            setWaitForRedux(false)
        }
      }, [reduxData])
      
  const [checked, setChecked] = useState(true)

  useEffect(()=>{
    getDestinationList();
  },[])

  const getDestinationList = async()=>{
    setInitialLoad(true);
     await getAuth(API_BASE_URL + 'management/fetch_specialfare_sectors')
        .then((response) => {
          if (response.data.status) {
            setAirportList(response.data.data)
            setInitialLoad(false);
          } else {
            setAirportList([])
            setInitialLoad(false);
          }
        }).catch((error) => {
        })
    }

  function TabPanel (props) {
    const { children, value, index, ...other } = props

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`nav-tabpanel-${index}`}
        aria-labelledby={`nav-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    )
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
  }

  function flightTabProps (index) {
    return {
      id: `nav-tab-${index}`,
      'aria-controls': `nav-tabpanel-${index}`
    }
  }

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper
    }
  }))
  const classes = useStyles()

  const [flightSearchType, setFlightSearchType] = useState(0)

  const handleFlightSearchType = (event, type) => {
    setFlightSearchType(type)
  }
  
  // if(initialLoad === true){
  //   return(
  //     <Backdrop
  //       sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
  //       open={true}
  //     //onClick={handleClose}
  //     >
  //       <CircularProgress color="inherit" />
  //     </Backdrop>
  //   );
  // }

  return (
    
        waitForRedux ? <Spinner /> :
    <>
    <Banner />
    <Container className="search-box search-box-sp">
      <Grid container spacing={0}>
        <Grid
          item
          lg={12}
          md={12}
          spacing={0}
          style={{ backgroundColor: '#fff', borderRadius: 0 }}
        >
          <Box pt={0}>
            <Tabs
              border={1}
              variant="fullWidth"
              indicatorColor="primary"
              centered
              textColor="primary"
              color="primary"
              value={flightSearchType}
              onChange={handleFlightSearchType}
              aria-label="nav tabs example"
              spacing={0}
              className="bg-white searchtab-sp"
            >
              <Tab
                className="tabTilte"
                variant="contained"
                label="Special Fares"
                {...flightTabProps(0)}
                style={{
                  borderTopLeftRadius: 0
                }}

              />
              
            </Tabs>

            <TabPanel className="tabsPanelbdr bg-white" value={flightSearchType} index={0}>
              <SpecialFare airportList = {airportList}/>
            </TabPanel>
          </Box>
        </Grid>
      </Grid>
    </Container>
    <GroupfaresLink />
    <SpecialOffer />
    <MobileAppBanner />
    <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={initialLoad}
      //onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* <Topdeals />
      <HotelTopdeals /> */}
      </>
    
  )
}

export default FlightSpecialFare
